import React, { Component } from 'react';

import Paper from 'material-ui/Paper';
import RaisedButton from 'material-ui/RaisedButton';
import Snackbar from 'material-ui/Snackbar';
import TextField from 'material-ui/TextField';

import ForgotPasswordDialog from './ForgotPasswordDialog';
import NavigationBar from './NavigationBar';
//import NavigationFooter from './NavigationFooter';
import * as Version from '../../../version';

import '../styles/authentication.css';

const style = {
  margin: 15,
};

class SignIn extends Component {
  constructor(props) {
    super(props);
    this.state = {
      email: '',
      password: '',
      isPasswordResetOpen: false,
      isPasswordResetSuccessOpen: false,
    };

    this.handleSubmit = this.handleSubmit.bind(this);
  }

  handlePasswordReset = () => {
    this.setState({isPasswordResetOpen: true});
  }

  handlePasswordResetSuccess = () => {
    this.setState({
      isPasswordResetSuccessOpen: true,
      isPasswordResetOpen: false
    });
  }

  handleSubmit(e) {
    e.preventDefault();
    this.props.onSignIn(this.state.email, this.state.password); 
  }

  render() {
    return (
      <div className='authentication-scene'>
        <NavigationBar />

        <div className="centered-box-container darker-background">
          <Paper zDepth={1}>
            <form className='form-box' onSubmit={this.handleSubmit}>
              <h2>Sign In To Your iHomework Account</h2>
              <TextField
                type="email"
                hintText="Email"
                floatingLabelText="Email"
                onChange={(event, newValue) => this.setState({email: newValue})}
              />
              <TextField
                type="password"
                hintText="Password"
                floatingLabelText="Password"
                onChange={(event, newValue) => this.setState({password: newValue})}
              />
              <RaisedButton
                type='submit'
                label="Sign In"
                primary={true}
                style={style}
              />

              <div className='forgot-password'>
                <a href='#' onClick={this.handlePasswordReset}>Forgot password?</a>
              </div>
            </form>
          </Paper>

          <div className='sign-in--help'>
            New to iHomework? Find out how to create an <a href='https://www.ihomeworkapp.com/app/support.html' target='_blank'>Account</a>.
          </div>

          <div className='privacy-notices'>
            <a target="_blank" href='https://www.ihomeworkapp.com/app/privacy.html'>Privacy Policy</a>
          </div>

          <div className='app-version'>
            {Version.version}
          </div>
        </div>

        <ForgotPasswordDialog
          open={this.state.isPasswordResetOpen}
          onClose={() => this.setState({isPasswordResetOpen: false})}
          onResetSuccess={this.handlePasswordResetSuccess} />

        <Snackbar
          open={this.state.isPasswordResetSuccessOpen}
          message="Reset email sent!"
          autoHideDuration={4000}
          onRequestClose={() => this.setState({isPasswordResetSuccessOpen: false})} />

      </div>
    );
  }
}

export default SignIn;


// WEBPACK FOOTER //
// ./src/scenes/Authentication/components/SignIn.js